var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5859 22.1758L14.0885 11.2479L14.1013 11.2582L20.8613 3.42578H18.6023L13.0954 9.80078L8.72227 3.42578H2.79766L9.79723 13.6284L9.79638 13.6275L2.41406 22.1758H4.67309L10.7955 15.0832L15.6613 22.1758H21.5859ZM7.82719 5.13032L18.3466 20.4712H16.5564L6.02852 5.13032H7.82719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.e91742f8b1b6c5d3a8f08b4153dee969.svg";
export { ForwardRef as ReactComponent };